var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { PureComponent } from 'react';
import { func, object, array, arrayOf, string, shape } from 'prop-types';
import Block from './blocks/block';
import Background from './elements/background/background';
import { sizeTraitToCssUnit, sizeTraitToClassMode } from './util';
import { MATCH_PARENT } from '../../data-parser/div-cards/props/predefined-size';
import { emptyFunc } from 'searchband-frontend-commons/util/func';
import * as CLS from './cls';

/**
 * Комопнент Div-ной карточки
 * JSON-schema @see https://github.yandex-team.ru/portal/morda-schema/tree/master/api/search/2/div
 */

var DivCard = function (_PureComponent) {
    _inherits(DivCard, _PureComponent);

    function DivCard() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, DivCard);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DivCard.__proto__ || Object.getPrototypeOf(DivCard)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
            var _this2 = _this,
                props = _this2.props;
            var action = props.states[props.stateIndex].action;


            if (action) {
                _this.invokeAction(action);
            }
        }, _this.handleAction = function (action) {
            _this.invokeAction(action);
        }, _this.invokeAction = function (action) {
            var _this3 = _this,
                props = _this3.props;


            props.onAction({
                action: action,
                cardId: props.id,
                messageId: props.messageId
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(DivCard, [{
        key: 'render',
        value: function render() {
            var props = this.props;
            var width = props.width;


            var style = {
                width: sizeTraitToCssUnit(width, 'auto')
            };

            var currentState = props.states[props.stateIndex];

            if (!currentState) {
                return null;
            }

            return React.createElement(
                'div',
                {
                    className: CLS.divCard(sizeTraitToClassMode(width))(),
                    style: style,
                    onClick: currentState.action ? this.handleClick : null
                },
                React.createElement(Background, {
                    background: props.background
                }),
                this.blocks
            );
        }
    }, {
        key: 'blocks',
        get: function get() {
            var _this4 = this;

            var props = this.props;
            var blocks = props.states[props.stateIndex].blocks;
            var width = props.width,
                onContentUpdated = props.onContentUpdated;


            return blocks.map(function (block, index) {
                return React.createElement(Block, {
                    key: block.id,
                    block: block,
                    width: width,
                    onAction: _this4.handleAction,
                    onContentUpdated: onContentUpdated
                });
            });
        }
    }]);

    return DivCard;
}(PureComponent);

DivCard.defaultProps = {
    states: [],
    background: [],
    width: MATCH_PARENT,
    onAction: emptyFunc
};
DivCard.propTypes = {
    states: array.isRequired,
    width: object,
    onAction: func,
    background: arrayOf(shape({
        color: string,
        type: string.isRequired
    })).isRequired
};
export default DivCard;